// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.12.0",
  date: "2026-10-13T13:00:38.226Z",
  gitInfo: {
    dirty: false,
    raw: "2c29bf719",
    hash: "2c29bf719",
    distance: null,
    tag: null,
    semver: null,
    suffix: "2c29bf719",
    semverString: null
  }
};
/* tslint:enable */
